import { Routes, createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from "react-router";

import { ReactIntegration, ReactRouterVersion, getWebInstrumentations, initializeFaro } from "@grafana/faro-react";
import { TracingInstrumentation } from "@grafana/faro-web-tracing";

const envPrefixMatch = /((\w+)(-))?cap-rx[.]com/.exec(window.location.hostname);

const collectorUrl =
  envPrefixMatch !== null ? `https://alloy.${envPrefixMatch[1] ?? ""}cap-rx.com/collect` : "http://127.0.0.1:10110/collect";

export const faro = initializeFaro({
  url: collectorUrl,
  app: {
    name: "adjudication",
    version: "1.0.0",
    environment: envPrefixMatch !== null ? envPrefixMatch[2] : "local",
  },
  instrumentations: [
    ...getWebInstrumentations({
      captureConsole: true,
    }),
    new TracingInstrumentation(),
    new ReactIntegration({
      router: {
        version: ReactRouterVersion.V7,
        dependencies: {
          createRoutesFromChildren,
          matchRoutes,
          Routes,
          useLocation,
          useNavigationType,
        },
      },
    }),
  ],
});
